var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"mediaplayer_"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"detailId") : depth0), depth0))
    + "\">\n    <div>\n        <iframe class=\"ratio ratio-16x9 w-100\"\n          src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"trailerContent") : depth0), depth0))
    + "\"\n              allowfullscreen\n              sandbox=\"allow-scripts allow-presentation allow-same-origin allow-popups\"\n              allow=\"autoplay; fullscreen; picture-in-picture; xr-spatial-tracking; encrypted-media; clipboard-write\">\n          </iframe>\n    </div>\n</div>\n\n";
},"useData":true});